import moment from 'moment';
import { Button } from '@tempmee/react';
import CheckCircleIcon from '../../../images/check-circle.svg';
import XCircleIcon from '../../../images/x-circle.svg';
import { Colors } from '../../../themes/colors';
import { capitalizeEveryFirstLetter } from '../../../utils/String';
import { TableData } from '../../../commonComponents/Table/TableData';
import { WC_MANAGEMENT_STATUS } from '../utils';

export const renderRow = (item, handleOnClick) => (
  <>
    <TableData text={item.officeName} />
    <TableData text={item.state} />
    <TableData
      text={item.requestedDate ? moment(item.requestedDate).format('ddd, MMM DD, YYYY') : '-'}
    />
    <td
      style={{
        fontFamily: 'Nunito',
        fontSize: 16,
        color: Colors.neutral_600,
        textAlign: 'center',
      }}
    >
      {item.workerClassificationType
        ? capitalizeEveryFirstLetter(item.workerClassificationType)
        : '-'}
    </td>
    <td>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
        }}
      >
        <Button
          variant="tertiary"
          size="xs"
          LeadingIcon={<img src={XCircleIcon} alt="" width={16} height={16} />}
          onClick={() => handleOnClick(item, WC_MANAGEMENT_STATUS.DECLINED)}
        >
          Decline
        </Button>
        <Button
          size="xs"
          LeadingIcon={<img src={CheckCircleIcon} alt="" width={16} height={16} />}
          onClick={() => handleOnClick(item, WC_MANAGEMENT_STATUS.CONFIRMED)}
        >
          Approve
        </Button>
      </div>
    </td>
  </>
);
